import { render, staticRenderFns } from "./WorkDaysSetupView.vue?vue&type=template&id=3c79790c&scoped=true&"
import script from "./WorkDaysSetupView.vue?vue&type=script&lang=ts&"
export * from "./WorkDaysSetupView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c79790c",
  null
  
)

export default component.exports